define("shared/components/shared/ui/social-profile-switcher/linkinbio/item", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <li class="o--dropBody__item" ...attributes>
    <a class="o--dropBody__link" {{on "click" (fn @onChange @socialProfile @linkinbioPage)}}>
      <Shared::Ui::SocialProfileSwitcher::Linkinbio::PageAvatar
        @linkinbioPage={{@linkinbioPage}}
        @socialProfile={{@socialProfile}}
      />
    </a>
  </li>
  */
  {
    "id": "exxP4Otk",
    "block": "[[[11,\"li\"],[24,0,\"o--dropBody__item\"],[17,1],[12],[1,\"\\n  \"],[11,3],[24,0,\"o--dropBody__link\"],[4,[38,0],[\"click\",[28,[37,1],[[30,2],[30,3],[30,4]],null]],null],[12],[1,\"\\n    \"],[8,[39,2],null,[[\"@linkinbioPage\",\"@socialProfile\"],[[30,4],[30,3]]],null],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"&attrs\",\"@onChange\",\"@socialProfile\",\"@linkinbioPage\"],false,[\"on\",\"fn\",\"shared/ui/social-profile-switcher/linkinbio/page-avatar\"]]",
    "moduleName": "shared/components/shared/ui/social-profile-switcher/linkinbio/item.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});